<button
  *ngIf="buttonText"
  class="btn btn-primary qr-code-btn"
  [class.inactive]="isButtonDisabled || disabled"
  [disabled]="isButtonDisabled || disabled"
  [ngbTooltip]="title"
  (click)="openModal()"
>
  {{ title }}
</button>

<img
  *ngIf="!buttonText"
  alt=""
  src="assets/images/scan-icon.svg"
  width="18"
  height="18"
  (click)="openModal()"
  [ngbTooltip]="title"
  class="{{ buttonIcon }} align-middle cursor-pointer"
/>
